import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const checkoutApi = createApi({
  reducerPath: "checkoutApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_CHECKOUT_API_V1_BASE_URL}`,
  }),
  endpoints: (builder) => ({
    getCheckoutConfig: builder.query({
      query: () => "/checkout/config",
    }),
    getCustomerOrderLimits: builder.query({
      query: (params) => ({
        url: "/checkout/customer-order-limits",
        params,
      }),
    }),
    getCheckoutOptionByZip: builder.query({
      query: (zip) =>
        `${import.meta.env.VITE_CHECKOUT_API_V2_BASE_URL}/zip/scope/${zip}`,
      transformResponse: (data) => data.scope,
    }),
    getZipCodeData: builder.query({
      query: (zip) => `/zip/data/${zip}`,
    }),
    getZipSchedule: builder.query({
      query: ({ zip, isAsrc = false }) =>
        `/schedule/slots/${zip}${isAsrc ? "/1" : ""}`,
    }),
    draftOrder: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: `${import.meta.env.VITE_CHECKOUT_API_V2_BASE_URL}/order/draft`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    addHawaiiGet: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: `${import.meta.env.VITE_CHECKOUT_API_V2_BASE_URL}/checkout/hawaii_get`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: data,
      }),
      invalidatesTags: ["Checkout"],
    }),
  }),
})

export const {
  useLazyGetCheckoutConfigQuery,
  useLazyGetCustomerOrderLimitsQuery,
  useLazyGetCheckoutOptionByZipQuery,
  useGetZipCodeDataQuery,
  useLazyGetZipCodeDataQuery,
  useLazyGetZipScheduleQuery,
  useDraftOrderMutation,
  useAddHawaiiGetMutation,
} = checkoutApi

export default checkoutApi
